// extracted by mini-css-extract-plugin
export var siteHeader = "header-module--siteHeader--5vFsl";
export var siteLogo = "header-module--siteLogo--AGLFZ";